<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="pAAu" style="margin-top:5em;">
					This book is dedicated to The Wellness Council<br/>
					for SC members, supporters, and volunteers. Past,<br/>
					present, and future. Thank you for everything!</p>
<p class="ct" id="pAb7">
					Our hope is that this book will help inspire a new<br/>
					generation to make themselves healthy and the<br/>
					world around them a better place to live.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication1.vue?d2b9bb22